import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BloodComponent from "./blood-component";
import Questions from "../../blood-donor/settings/questions";
import BloodProducts from "../../blood-donor/settings/blood-products";
import BloodDonorPageHeader, { HeaderPreview } from "../../blood-donor/page-header";
import OtherConfig from "./other-config";

const BloodBankSettings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  // Tab mapping for URL routing
  const tabRoutes = [
    { path: "blood-component", index: 0 },
    { path: "medical-questions", index: 1 },
    { path: "blood-product", index: 2 },
    { path: "page-header", index: 3 },
    { path: "other-config", index: 4 },
  ];

  // Set active tab based on current URL
  useEffect(() => {
    const currentPath = window.location.pathname.split("/").pop();
    
    const matchedTab = tabRoutes.find(tab => tab.path === currentPath);
    if (matchedTab) {
      setActiveTab(matchedTab.index);
    }
  }, [tabRoutes]);
  console.log("fghjk",window.location.pathname.split("/").pop());

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    const selectedRoute = tabRoutes[newValue];
    if (selectedRoute) {
      navigate(`/blood-bank/settings/${selectedRoute.path}`);
    }
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: "100%", p: 1 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          backgroundColor: "white",
          borderRadius: "4px 4px 0 0",
          px: 2,
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="account dashboard tabs"
        >
          <Tab
            sx={{ fontSize: ".75rem", pointerEvents: "auto" }}
            label="Blood Component"
          />  
          <Tab
            sx={{ fontSize: ".75rem", pointerEvents: "auto" }}
            label="Medical Questions"
          />  
          <Tab
            sx={{ fontSize: ".75rem", pointerEvents: "auto" }}
            label="Blood Product"
          />  
          <Tab
            sx={{ fontSize: ".75rem", pointerEvents: "auto" }}
            label="Page Header"
          />
          <Tab
            sx={{ fontSize: ".75rem", pointerEvents: "auto" }}
            label="Other Config"
          />  
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <Box
          sx={{ pt: 2, backgroundColor: "white", borderRadius: "0 0 8px 8px" }}
        >
         <BloodComponent />
        </Box>
      )}
      {activeTab === 1 && (
        <Box
          sx={{ pt: 2, backgroundColor: "white", borderRadius: "0 0 8px 8px" }}
        >
         <Questions />
        </Box>
      )}
      {activeTab === 2&& (
        <Box
          sx={{ pt: 2, backgroundColor: "white", borderRadius: "0 0 8px 8px" }}
        >
         <BloodProducts />
        </Box>
      )}
      {activeTab === 3 && (
        <Box
          sx={{ pt: 2, backgroundColor: "white", borderRadius: "0 0 8px 8px" }}
        >
        <BloodDonorPageHeader/>
        </Box>
      )}
      {activeTab === 4 && (
        <Box
          sx={{ pt: 2, backgroundColor: "white", borderRadius: "0 0 8px 8px" }}
        >
          <OtherConfig />
        </Box>
      )}
    </Box>
  );
};
export default BloodBankSettings
